export default __webpack_public_path__ + "static/media/bg_faces_gradient.77404fff.jpg";